import(/* webpackMode: "eager", webpackExports: ["HomeFeature"] */ "/app/main/src/features/home/HomeFeature.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.1.0_next@15.3.3_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.89.2__react@19.1.0_typescript@5.8.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sub/ui/src/layout/MainLayout/MainLayout.tsx");
